
import {Component, Prop, Ref, Vue} from "vue-property-decorator";
import {BModal} from "bootstrap-vue";
import LoadingButton from "@/components/general/buttons/LoadingButton.vue";
import {Contact, ContactType} from "@/shared/domain/General";
import {toI18nOptions} from "@/utils/Utils";
import {organisationValidator, personValidator} from "@/components/form/Validators";
import {Loader} from "@/utils/Loader";

@Component({
  components: {LoadingButton}
})
export default class SearchContactComponent extends Vue {
  @Prop() value!: Contact

  private loader = Loader.create()

  private formSchema = {}
  private form: Form = this.createEmptyForm()
  private formValid = false
  private formOptions = {
    validateAfterLoad: true,
    validateAfterChanged: true
  };

  @Ref("modal")
  modal!: BModal

  get types(): Array<ContactType> {
    return [ContactType.ORGANISATION, ContactType.PERSON]
  }

  mounted() {
    this.formSchema = {
      fields: [
        {
          type: 'vueSelect',
          label: this.$t('finance.bill.contact.type.name'),
          model: 'type',
          values: toI18nOptions(this.types, 'finance.bill.contact.type', this),
          onChanged: (model: Form, val: any) => {
            model.contact = undefined
          },
          styleClasses: 'col-12 pr-0 pl-0',
          required: true,
          validator: "string"
        },
        {
          type: 'organisationSearch',
          label: this.$t('finance.bill.contact.title'),
          model: 'contact',
          visible: (model: Form) => {
            return model && model.type === ContactType.ORGANISATION
          },
          onChanged: (model: Form, val: any) => {
            this.loader.load(async () => {
              if (val) {
                model.contact = {
                  ref: val.ref,
                  name: val.name,
                  type: ContactType.ORGANISATION
                }
              } else {
                model.contact = undefined
              }
            })
          },
          styleClasses: 'col-12 pr-0 pl-0',
          validator: organisationValidator
        },
        {
          type: 'personSearch',
          label: this.$t('finance.bill.contact.title'),
          model: "contact",
          visible: (model: Form) => {
            return model && model.type === ContactType.PERSON
          },
          onChanged: (model: Form, val: any) => {
            this.loader.load(async () => {
              if (val) {
                model.contact = {
                  ref: val.ref,
                  name: val.name,
                  type: ContactType.PERSON
                }
              } else {
                model.contact = undefined
              }
            })
          },
          styleClasses: 'col-12 pr-0 pl-0',
          validator: personValidator
        }
      ]
    }
  }

  formValidated(isValid: boolean) {
    this.formValid = isValid
  }

  openModal() {
    this.form = this.createEmptyForm()
    this.modal.show()
  }

  save() {
    this.$emit("input", this.form.contact)
    this.close()
  }

  private close() {
    this.modal.hide()
  }

  private createEmptyForm() {
    return {
      type: ContactType.ORGANISATION,
      contact: undefined
    } as Form
  }
}

export interface Form {
  type: ContactType
  contact?: Contact
}
